import * as UserCard from './components/UserCard.css';

export default {
	UserCard
};
